import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nl from "./translations/nl/common.json";
import en from "./translations/en/common.json";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    debug: true,
    resources: {
      en: {
        translation: en,
      },
      nl: {
        translation: nl,
      },
    },
  });

export default i18next;
